module.exports = __webpack_public_path__ + "static/media/user.52a1200a.svg";